import AdminGuard from '@/views/dashboard/guards/AdminGuard'
import RouterView from '@/components/RouterView'
import PeriodList from './PeriodList'
import User from './User'
import Group from './Group'

export default [
    {
        path: 'pendaftaran',
        component: RouterView,
        beforeEnter: AdminGuard,
        children: [
            { path: '', component: PeriodList, name: 'registration', meta: { title: 'Pendaftaran' } },
            { path: ':period_id', component: User, name: 'registration.user' },
        ]
    }, {
        path: 'pendaftarankelompok',
        component: Group,
        beforeEnter: AdminGuard,
        meta: { title: 'Pendaftaran Kelompok' },
        name: 'registration.group'
    }
]
